"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class DatabaseUtils {
    static clear(db) {
        return __awaiter(this, void 0, void 0, function* () {
            const keysToClear = new Array();
            return new Promise((resolve, reject) => {
                db.createKeyStream()
                    .on("data", (key) => {
                    keysToClear.push(key);
                })
                    .on("error", (error) => {
                    reject(error);
                })
                    .on("close", () => __awaiter(this, void 0, void 0, function* () {
                    for (const key of keysToClear) {
                        yield db.del(key);
                    }
                    resolve();
                }));
            });
        });
    }
}
exports.DatabaseUtils = DatabaseUtils;
//# sourceMappingURL=utils.js.map